module.exports = __webpack_public_path__ + "img/dropdown-menu-solution-1-2.bef609e9.png";